export class CreateSupplierInvoiceDto {}
